import { DishTag } from 'src/gqlReactTypings.generated.d';
import Chip, { ChipColor } from 'web-common/src/shared/design-system/components/Chip';
import { Icon, IconName } from 'web-common/src/shared/design-system/components/Icon';

export const DISH_TAG_CONFIG: Record<DishTag, { label: string; iconName: IconName }> = {
  [DishTag.AntibioticFree]: { label: 'Antibiotic Free', iconName: 'antibioticFree' },
  [DishTag.LocallySourced]: { label: 'Locally Sourced', iconName: 'locallySourced' },
  [DishTag.PastureRaised]: { label: 'Pasture Raised', iconName: 'pastureRaised' },
};

/** Display order for all food item tags (dish tags + isSeedOilFree). */
const TAG_DISPLAY_ORDER: ('seedOilFree' | DishTag)[] = [
  DishTag.PastureRaised,
  DishTag.LocallySourced,
  'seedOilFree',
  DishTag.AntibioticFree,
];

interface FoodItemTagChipsProps {
  isSeedOilFree?: boolean | null;
  tags?: DishTag[] | null;
}

export const FoodItemTagChips: React.FC<FoodItemTagChipsProps> = ({ isSeedOilFree, tags }) => {
  const tagSet = new Set(tags ?? []);
  const chips: React.ReactNode[] = [];

  for (const entry of TAG_DISPLAY_ORDER) {
    if (entry === 'seedOilFree') {
      if (isSeedOilFree) {
        chips.push(
          <Chip
            key='seedOilFree'
            color={ChipColor.MINT_50}
            copy='Seed Oil Free'
            icon={<Icon name='seedOilFree' size={16} />}
            applyFullHeight
          />
        );
      }
    } else if (tagSet.has(entry)) {
      const config = DISH_TAG_CONFIG[entry];
      chips.push(
        <Chip
          key={entry}
          color={ChipColor.MINT_50}
          copy={config.label}
          icon={<Icon name={config.iconName} size={16} />}
          applyFullHeight
        />
      );
    }
  }

  if (chips.length === 0) {
    return null;
  }

  return <>{chips}</>;
};
